import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/utils";
import { Carousel, CarouselContent, CarouselItem, CarouselDots, CarouselNext } from "@repo/ui/carousel";
import { Icon } from "@repo/ui/icon";
import { Tag } from "@repo/ui/tag";
import { VisualWrapper } from "@/components/common/visual/visual.component";
import { getI18nString } from "@/lib/utils";
import type { VisualType } from "@/lib/types";
import type { ApartmentRef } from "./apartment-card.types";
import type { IconName } from "@repo/ui/icon";
interface ApartmentCardMultipleProps {
  apartment: ApartmentRef;
  className?: string;
}
export function ApartmentCardMultiple(t0) {
  const $ = _c(40);
  const {
    apartment,
    className
  } = t0;
  const content = apartment.apartmentListingContent;
  let description;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== apartment.availabilityOverline || $[1] !== className || $[2] !== content) {
    const images = (content?.visual?.mediaSource ?? []).map(_temp);
    const hasMultipleImages = images.length > 1;
    let t9;
    if ($[12] !== content) {
      t9 = (content ? getI18nString(content.headline) : undefined) || "";
      $[12] = content;
      $[13] = t9;
    } else {
      t9 = $[13];
    }
    const title = t9;
    const tags = content?.highlightTags ?? [];
    let t10;
    if ($[14] !== content) {
      t10 = content ? getI18nString(content.description) || undefined : undefined;
      $[14] = content;
      $[15] = t10;
    } else {
      t10 = $[15];
    }
    description = t10;
    t6 = "apartment-card-multiple";
    if ($[16] !== className) {
      t7 = cn("flex w-full flex-col gap-6", className);
      $[16] = className;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    const t11 = images.length > 0 ? <Carousel loop={hasMultipleImages}><CarouselContent>{images.map(_temp2)}</CarouselContent>{hasMultipleImages && <><CarouselNext className="absolute right-4 top-1/2 -translate-y-1/2 shadow-md" /><CarouselDots className="absolute bottom-4 left-1/2 -translate-x-1/2" dotClassName="bg-white/40" activeDotClassName="bg-white" /></>}</Carousel> : <div className="flex aspect-square w-full items-center justify-center bg-surface-base-secondary tablet:aspect-auto h-full"><Icon name="image" className="size-12 text-text-disabled" /></div>;
    if ($[18] !== t11) {
      t8 = <div className="relative aspect-square w-full overflow-clip rounded-md">{t11}</div>;
      $[18] = t11;
      $[19] = t8;
    } else {
      t8 = $[19];
    }
    t5 = "flex w-full flex-col gap-4";
    t1 = "flex w-full flex-col gap-3";
    if ($[20] !== apartment.availabilityOverline) {
      t2 = apartment.availabilityOverline && <p className="typography-component-xs-medium text-text-secondary">{apartment.availabilityOverline}</p>;
      $[20] = apartment.availabilityOverline;
      $[21] = t2;
    } else {
      t2 = $[21];
    }
    if ($[22] !== title) {
      t3 = <h3 className="typography-mobile-heading-subtitle-1 text-text-primary tablet:typography-desktop-heading-subtitle-1">{title}</h3>;
      $[22] = title;
      $[23] = t3;
    } else {
      t3 = $[23];
    }
    t4 = tags.length > 0 && <div className="flex flex-wrap items-center gap-2">{tags.slice(0, 4).map(_temp3)}</div>;
    $[0] = apartment.availabilityOverline;
    $[1] = className;
    $[2] = content;
    $[3] = description;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    description = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
  }
  let t9;
  if ($[24] !== t1 || $[25] !== t2 || $[26] !== t3 || $[27] !== t4) {
    t9 = <div className={t1}>{t2}{t3}{t4}</div>;
    $[24] = t1;
    $[25] = t2;
    $[26] = t3;
    $[27] = t4;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== description) {
    t10 = description && <p className="typography-body-xs-regular text-text-secondary">{description}</p>;
    $[29] = description;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t10 || $[32] !== t5 || $[33] !== t9) {
    t11 = <div className={t5}>{t9}{t10}</div>;
    $[31] = t10;
    $[32] = t5;
    $[33] = t9;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== t11 || $[36] !== t6 || $[37] !== t7 || $[38] !== t8) {
    t12 = <div data-testid={t6} className={t7}>{t8}{t11}</div>;
    $[35] = t11;
    $[36] = t6;
    $[37] = t7;
    $[38] = t8;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  return t12;
}
function _temp3(tag) {
  return <Tag key={tag._id} variant="light" size="sm" iconLeft={tag.icon as IconName | undefined}>{getI18nString(tag.headline, "")}</Tag>;
}
function _temp2(image, index) {
  return <CarouselItem key={index}><div className="relative aspect-square w-full"><VisualWrapper visual={image} asBackground={true} className="size-full" visualClassName="size-full" imgClassName="object-cover" extraImageProps={{
        sizes: "(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw",
        cropAspect: 1
      }} /></div></CarouselItem>;
}
function _temp(source) {
  return {
    mediaSource: source
  } as VisualType;
}